import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=ee63f502&scoped=true&"
import script from "./CompanyDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=ee63f502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee63f502",
  null
  
)

export default component.exports